var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57074 22.5346L13.7306 13.4752L18.8905 22.5346H8.57074ZM7.29584 2.19398L12.8816 12.002L7.29584 21.8099L1.55681 12.002L7.29584 2.19398ZM13.7306 10.5297L8.56877 1.46827H18.8905L13.7306 10.5297ZM14.5687 12.0029L20.7781 1.09847C20.9778 0.747541 20.8572 0.299195 20.5074 0.0983825C20.3977 0.034759 20.2722 0.00195312 20.1456 0.00195312H7.31363C7.05569 0.00195312 6.81652 0.140136 6.68606 0.363812L0.100065 11.6311C-0.033355 11.8598 -0.033355 12.1441 0.100065 12.3728L6.68606 23.6401C6.81652 23.8648 7.05569 24.002 7.31363 24.002H20.1456C20.5478 24.002 20.874 23.6739 20.875 23.2693C20.875 23.1411 20.8424 23.0158 20.7792 22.9045L14.5687 12.0009V12.0029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutCom);
export default __webpack_public_path__ + "static/media/checkoutCom.35922b148c77ecf8f0df9b2c4cd5fb05.svg";
export { ForwardRef as ReactComponent };